// extracted by mini-css-extract-plugin
module.exports = {"price":"Price_price__3zvlS"};